export const APP_VERSION = 'v2.0.3'
